/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
import urlJoin from 'url-join';

export function joinUrls(...parts: string[]) {
  return urlJoin(parts);
}
